export class TicketSubject {
  constructor() {}
  name: string;
  status: number;
  _id: string;
}
